module.exports = "<app-subnav [subnav]=\"'education.subnav' | translate\"></app-subnav>\r\n<!--<app-education-main></app-education-main>-->\r\n<router-outlet (deactivate)=\"onDeactivate()\"></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/education/education/education.component.html
// module id = ../../../../../src/app/components/education/education/education.component.html
// module chunks = main